import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Create async thunk to fetch the job list
export const fetchJobList = createAsyncThunk(
  'jobList/fetchJobList',
  async (_, { rejectWithValue }) => {
    try {
      const ticketToken = sessionStorage.getItem('ticketToken');
      if (!ticketToken) {
        throw new Error('No ticket token found in sessionStorage');
      }

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/provider/get-recent-jobs`,
        {
          headers: {
            Authorization: `Bearer ${ticketToken}`,
          },
        }
      );
      console.log("API Response Data: ", response.data); // Debugging line
      return response.data.data || [];
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

const jobListSlice = createSlice({
  name: 'jobList',
  initialState: {
    jobs: [
      { jobTitle: 'No jobs available yet', status: 'Status' },
      { jobTitle: 'Create your first job post', status: 'Action Required' },
      { jobTitle: 'Sample Job: Healthcare Assistant', status: 'Pending' },
      { jobTitle: 'No jobs have been assigned yet', status: 'Status' },
    ],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobList.fulfilled, (state, action) => {
        state.loading = false;
        console.log("Fetched Jobs: ", action.payload); // Debugging line
        state.jobs = action.payload.length > 0 ? action.payload : [
        { jobTitle: 'No jobs available yet', status: 'Status' },
        { jobTitle: 'Create your first job post', status: 'Action Required' },
        { jobTitle: 'Sample Job: Healthcare Assistant', status: 'Pending' },
        { jobTitle: 'No jobs have been assigned yet', status: 'Status' },
        ];
      })
      .addCase(fetchJobList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default jobListSlice.reducer;
